const prefix = 'game';

export const addHighLighted = `${prefix}/highlighted`;

export const toggleHighlight = (gameId) => `${prefix}/${gameId}/highlighted`;
